import { Dispatch } from 'redux';
import { personScreenableValuesCalculationApi, searchIndexApi } from '../apis';
import { InternalApiIndexType } from '../api-internal';
import { showFeedback } from '../feedback/feedbackReducer';

export const recreateIndex =
  (indexType: InternalApiIndexType | undefined, customListCode: string | undefined) => async (dispatch: Dispatch) => {
    let message: string;
    if (indexType === InternalApiIndexType.DOW_JONES) {
      message = 'Created all DJ indexes and started reindexing!';
    } else {
      message = `Created ${indexType != null ? indexType : customListCode} index and started reindexing!`;
    }
    try {
      await searchIndexApi.recreate({
        internalApiRecreateIndex: {
          type: indexType,
          customList: customListCode,
        },
      });
      dispatch(
        showFeedback({
          message: message,
          success: true,
        })
      );
    } catch (_) {
      dispatch(
        showFeedback({
          message: 'Oops, something went wrong!',
          success: false,
        })
      );
    }
  };

export const calculatePersonScreenableValues = async (dispatch: Dispatch) => {
  try {
    await personScreenableValuesCalculationApi.recalculatePersonScreenableValues();
    dispatch(
      showFeedback({
        message: 'Person screenable value indexing started',
        success: true,
      })
    );
  } catch (_) {
    dispatch(
      showFeedback({
        message: 'Oops, something went wrong!',
        success: false,
      })
    );
  }
};
